import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import RadialChart1 from "./userpanelChart1";
import axios from "axios";

const UserPanel = () => {
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalCourses, setTotalCourses] = useState(0);
  const [totalAssignedCourses, setTotalAssignedCourses] = useState(0);

  useEffect(() => {
    const fetchUsersData = async () => {
      try {
        const token = localStorage.getItem("token"); // Retrieve token from local storage

        // Fetch user data
        const userResponse = await axios.get("https://uma.aasmo.in/api/admin/getall-users", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Update state with the total users count from the response
        setTotalUsers(userResponse.totalUsers); // Access totalUsers correctly

        // Calculate total assigned courses
        const assignedCoursesCount = userResponse.users.reduce((count, user) => {
          return count + user.courses.length; // Add the length of the courses array for each user
        }, 0);
        setTotalAssignedCourses(assignedCoursesCount); // Update state with the total assigned courses count

        // Fetch courses data (if you need to show total courses as well)
        const courseResponse = await axios.get("https://uma.aasmo.in/api/admin/getall-category", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Update state with the total courses count
        setTotalCourses(courseResponse.length); // Count of courses
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchUsersData();
  }, []);

  return (
    <React.Fragment>
      <Row>
        <Col xl={12} sm={12}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div id="radialchart-1" className="apex-charts" dir="ltr">
                    <RadialChart1 series={[totalUsers]} />
                  </div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Total Users</p>
                  <h5 className="mb-3">{totalUsers}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={12} sm={12}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div id="radialchart-2" className="apex-charts" dir="ltr">
                    <RadialChart1 series={[totalCourses]} />
                  </div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Total Courses</p>
                  <h5 className="mb-3">{totalCourses}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={12} sm={12}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div id="radialchart-3" className="apex-charts" dir="ltr">
                    <RadialChart1 series={[totalAssignedCourses]} />
                  </div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Total Assigned Courses</p>
                  <h5 className="mb-3">{totalAssignedCourses}</h5>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UserPanel;
